<template>
  <div>
    <v-form @submit.prevent="submitForm">
      <v-text-field
        v-model="form.personalName"
        variant="outlined"
        label="Jméno a příjmení"
        :error-messages="getViolation('personalName')"
      />

      <v-row>
        <v-col
          :cols="12"
          :md="6"
        >
          <v-text-field
            v-model="form.email"
            variant="outlined"
            label="Váš e-mail"
            :error-messages="getViolation('email')"
          />
        </v-col>

        <v-col
          :cols="12"
          :md="6"
        >
          <v-text-field
            v-model="form.phone"
            variant="outlined"
            label="Váš telefon"
            :error-messages="getViolation('phone')"
          />
        </v-col>
      </v-row>

      <v-text-field
        v-model="form.placeOfRealization"
        variant="outlined"
        label="Místo realizace"
        :error-messages="getViolation('placeOfRealization')"
        placeholder="Uveďte prosím místo pro realizaci"
      />

      <v-textarea
        v-model="form.body"
        variant="outlined"
        label="Text zprávy"
        placeholder="Text zprávy"
        :error-messages="getViolation('body')"
      />

      <div class="d-flex align-start mb-5 ga-2 text-left">
        <v-checkbox
          v-model="accepted"
          hide-details
          density="compact"
          class="ma-0 mt-n2 flex-shrink-0"
        />
        <small>
          Odesláním formuláře souhlasíte se zpracováním osobních údajů (jméno, e‑mail, telefon) za účelem vyřízení Vaší poptávky v souladu se <a
            target="_blank"
            style="color: #ffea0b;"
            href="/ochrana-osobnich-udaju"
          >zásadami ochrany osobních údajů</a>. Vaše údaje uchováváme pouze po dobu nezbytnou k vyřízení poptávky a nevyužíváme je k dalším účelům.
        </small>
      </div>

      <div class="d-flex justify-end">
        <v-btn
          type="submit"
          :loading="loading"
          :disabled="!accepted"
          variant="outlined"
          color="#ffea0b"
        >
          Odeslat
        </v-btn>
      </div>

    </v-form>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Axios from '../ajax'
import Qs from 'qs'
import { useErrorHandler } from '@/composables/useErrorHandler'

const props = defineProps<{
  csrfToken: string
  topic?: string
}>()

const { getViolation, clearViolations, buildViolations } = useErrorHandler()

const loading = ref(false)
const accepted = ref(false)
const form = ref({
  personalName: '',
  email: '',
  phone: '',
  placeOfRealization: '',
  body: ''
})

async function submitForm() {
  clearViolations()
  loading.value = true

  try {
    await Axios.post('/kontaktni-formular', Qs.stringify({
      personalName: form.value.personalName,
      email: form.value.email,
      phone: form.value.phone,
      placeOfRealization: form.value.placeOfRealization,
      body: form.value.body,
      topic: props.topic ?? '',
      _token: props.csrfToken
    }))

    window.location.href = '/odeslanyformular'
  } catch (e: any) {
    buildViolations(e.response)
    loading.value = false
  }
}
</script>
